module.exports = __webpack_public_path__ + "img/teeth-36.b39eed08.png";